module.exports = __webpack_public_path__ + "img/prem_after.11e8f541.jpg";